import { api } from '@utils/ky.util';

export const fetchQrSummation = async (data, path = 'check_summation') => {
  return await api
    .post(path, {
      json: {
        chat_id: data.user.chat_id,
        lang: data.user.lang,
        contact_id: data.user.contact_id,
        initiator_id: data.user.initiator_id,
        qr_data: data.qrCode,
      },
    })
    .json();
};
